import { AxiosResponse } from "axios";
import apiService from "services/apiService";

// Shape returned by all config type APIs: { id, name }
export interface ConfigItem {
  id: number;
  name: string;
}

class AdminConfigService {
  getAll(endpoint: string): Promise<AxiosResponse<ConfigItem[]>> {
    return apiService.get(endpoint);
  }

  add(endpoint: string, names: string[]): Promise<AxiosResponse<ConfigItem[]>> {
    return apiService.post(endpoint, { names });
  }

  update(endpoint: string, id: number, name: string): Promise<AxiosResponse<ConfigItem>> {
    return apiService.put(`${endpoint}/${id}`, { name });
  }

  remove(endpoint: string, id: number): Promise<AxiosResponse<void>> {
    return apiService.delete(`${endpoint}/${id}`);
  }
}

const adminConfigService = new AdminConfigService();
export default adminConfigService;
